import React from 'react';
import PropTypes from 'prop-types';

import BubbleContent from 'components/customer/conversation_history/conversation_items_v2/content/bubble_content';
import DataDisplayItem from 'components/customer/conversation_history/conversation_items_v2/automation/data_display_item';
import ConversationItem from 'models/conversation_item';

export default function ChatDataDisplayContent({ className, item, status, withoutBubble }) {
  const content = (
    <DataDisplayItem displayContent={item.content.messageData.displayContent} type={item.content.messageData.type} />
  );

  return withoutBubble ? (
    content
  ) : (
    <BubbleContent className={className} item={item} status={status}>
      {content}
    </BubbleContent>
  );
}

ChatDataDisplayContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  status: PropTypes.string,
  withoutBubble: PropTypes.bool,
};
